var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6F6F6F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 12h3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    calcMode: "spline",
    dur: "560ms",
    keySplines: "0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1",
    keyTimes: "0; 0.09; 0.125; 0.215; 0.25; 0.34; 0.375; 1",
    repeatCount: "indefinite",
    values: "#6F6F6F; #6F6F6F; #B0B0B0; #B0B0B0; #D9D9D9; #D9D9D9; #E5E5E5; #E5E5E5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.636 5.636 2.122 2.121"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    calcMode: "spline",
    dur: "560ms",
    keySplines: "0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1",
    keyTimes: "0; 0.09; 0.125; 0.215; 0.25; 0.34; 0.375; 0.465; 0.5; 1",
    repeatCount: "indefinite",
    values: "#E5E5E5; #E5E5E5; #6F6F6F; #6F6F6F; #B0B0B0; #B0B0B0; #D9D9D9; #D9D9D9; #E5E5E5; #E5E5E5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 3v3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    calcMode: "spline",
    dur: "560ms",
    keySplines: "0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1",
    keyTimes: "0; 0.215; 0.25; 0.34; 0.375; 0.465; 0.5; 0.59; 0.625; 1",
    repeatCount: "indefinite",
    values: "#E5E5E5; #E5E5E5; #6F6F6F; #6F6F6F; #B0B0B0; #B0B0B0; #D9D9D9; #D9D9D9; #E5E5E5; #E5E5E5"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.364 5.636-2.121 2.121"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    calcMode: "spline",
    dur: "560ms",
    keySplines: "0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1",
    keyTimes: "0; 0.34; 0.375; 0.465; 0.5; 0.59; 0.625; 0.715; 0.75; 1",
    repeatCount: "indefinite",
    values: "#E5E5E5; #E5E5E5; #6F6F6F; #6F6F6F; #B0B0B0; #B0B0B0; #D9D9D9; #D9D9D9; #E5E5E5; #E5E5E5"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 12h-3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    calcMode: "spline",
    dur: "560ms",
    keySplines: "0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1",
    keyTimes: "0; 0.465; 0.5; 0.59; 0.625; 0.715; 0.75; 0.84; 0.875; 1",
    repeatCount: "indefinite",
    values: "#E5E5E5; #E5E5E5; #6F6F6F; #6F6F6F; #B0B0B0; #B0B0B0; #D9D9D9; #D9D9D9; #E5E5E5; #E5E5E5"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.364 18.364-2.121-2.121"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    calcMode: "spline",
    dur: "560ms",
    keySplines: "0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1",
    keyTimes: "0; 0.59; 0.625; 0.715; 0.75; 0.84; 0.875; 0.965; 1",
    repeatCount: "indefinite",
    values: "#E5E5E5; #E5E5E5; #6F6F6F; #6F6F6F; #B0B0B0; #B0B0B0; #D9D9D9; #D9D9D9; #E5E5E5"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 21v-3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    calcMode: "spline",
    dur: "560ms",
    keySplines: "0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1",
    keyTimes: "0; 0.09; 0.125; 0.75; 0.84; 0.875; 0.965; 1",
    repeatCount: "indefinite",
    values: "#D9D9D9; #D9D9D9; #E5E5E5; #E5E5E5; #6F6F6F; #6F6F6F; #B0B0B0; #B0B0B0"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0B0B0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.636 18.364 2.122-2.121"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    calcMode: "spline",
    dur: "560ms",
    keySplines: "0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1; 0, 0, 0.58, 1",
    keyTimes: "0; 0.09; 0.125; 0.215; 0.25; 0.84; 0.875; 0.965; 1",
    repeatCount: "indefinite",
    values: "#B0B0B0; #B0B0B0; #D9D9D9; #D9D9D9; #E5E5E5; #E5E5E5; #6F6F6F; #6F6F6F; #B0B0B0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.d33f36fb050d368e5cedb41e86fa4484.svg";
export { ForwardRef as ReactComponent };